import "core-js/modules/es.array.push.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import { h, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Home, Find, My, Category, Cart } from '@nutui/icons-vue';
// import NewList from './NewList.vue'
// import HistoryList from './HistoryList.vue'
import MyViewVue from './MyView.vue';
// import FutureList from './FutureList.vue'
import MacthList from './MacthList.vue';
import CollectList from './CollectList.vue';
import SendView from './SendView.vue';
import Spdex from './Spdex.vue';
// import OldView from './OldView.vue'

export default {
  __name: 'HomeView',
  setup(__props) {
    const List = [{
      title: '主页',
      icon: h(Home),
      to: MacthList
    },
    // {
    //   title: '历史',
    //   icon: h(Find),
    //   to: HistoryList
    // },
    {
      title: '计算',
      icon: h(Category),
      to: Spdex
    },
    // {
    //   title: '聊天',
    //   icon: h(Find),
    //   to: SendView
    // },
    // {
    //   title: '老的',
    //   icon: h(Category),
    //   to: NewList
    // },
    {
      title: '我的',
      icon: h(My),
      to: MyViewVue
    }];
    const store = useStore();
    const router = useRouter();
    const tabSwitch = (item, index) => {
      // 点击"我的"且未登录：切回主页并跳转登录页（登录后自动回首页）
      if (index == 2 && !store.state.isLoggedIn) {
        active.value = 0;
        localStorage.setItem('tabSwitch', 0);
        router.push({
          path: '/login',
          query: {
            redirect: '/home'
          }
        });
        return;
      }
      localStorage.setItem('tabSwitch', index);
    };
    const active = ref(localStorage.getItem("tabSwitch") != undefined ? localStorage.getItem("tabSwitch") : 0);
    return (_ctx, _cache) => {
      const _component_nut_tabbar_item = _resolveComponent("nut-tabbar-item");
      const _component_nut_tabbar = _resolveComponent("nut-tabbar");
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(List[active.value].to), {
        style: {
          height: '94vh',
          overflow: 'auto'
        }
      })), _createVNode(_component_nut_tabbar, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        bottom: "",
        "safe-area-inset-bottom": "",
        placeholder: "",
        onTabSwitch: tabSwitch
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(List, (item, index) => {
          return _createVNode(_component_nut_tabbar_item, {
            key: index,
            "tab-title": item.title,
            icon: item.icon
          }, null, 8, ["tab-title", "icon"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};